import Markdown, { type Components } from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import { normalizeLegacyEscapes } from './normalizeLegacyEscapes';
import * as s from './MarkdownEditor.css';

export interface MarkdownViewerProps {
  value: string;
  /** 요소 치환 — 호출부의 제목 위계에 맞춰 본문 제목을 낮출 때 쓴다(예: 팀 이름 h3 아래 h4). */
  components?: Components;
}

/**
 * 읽기 전용 마크다운 뷰어 — react-markdown + remark-gfm 만 사용한다.
 *
 * MarkdownEditor 의 readOnly 분기를 별도 컴포넌트로 분리한 것. MarkdownEditor 는 useEditor()
 * 를 무조건 호출(8 tiptap extension + ProseMirror 인스턴스 + turndown)하므로, 뷰잉만 필요한
 * 곳에서 readOnly 로 써도 에디터가 인스턴스화됐다 폐기됐다. HistoryView 처럼 리스트로 N개
 * 렌더되는 곳에서는 행마다 ProseMirror 1개가 생성·폐기되던 비용이 발생.
 *
 * 이 컴포넌트의 의존 경로에는 tiptap/turndown 이 없고, 편집기 인스턴스를 만들지 않는다.
 *
 * remark-breaks 를 함께 쓰는 이유: 마크다운 기본 규칙은 단일 개행을 무시해 <p> 안에
 * 리터럴 개행으로 남기고, 렌더 경로에 white-space 지정이 없어 브라우저가 공백 한 칸으로
 * 붕괴시킨다. 이 뷰어가 그리는 것은 전부 사람이 직접 쓴 글(퀘스트 설명은 평문 Textarea,
 * 워크로그는 에디터)이라 "엔터를 친 곳에서 줄이 바뀐다"가 저자 의도에 맞다.
 * 블록 구조와 빈 줄 문단 분리는 그대로 두고 <p>·<li> 안의 단일 개행만 <br> 이 된다.
 *
 * normalizeLegacyEscapes: 옛 에디터가 저장할 때마다 덧씌운 백슬래시가 이력 화면에도
 * 그대로 보이므로 에디터와 같은 규칙으로 걷어낸다 — 두 화면이 같은 글을 다르게 보여주지
 * 않게 하기 위한 것이다.
 */
export function MarkdownViewer({ value, components }: MarkdownViewerProps) {
  return (
    <div className={s.markdownBody}>
      {value ? (
        <Markdown remarkPlugins={[remarkGfm, remarkBreaks]} components={components}>
          {normalizeLegacyEscapes(value)}
        </Markdown>
      ) : (
        <span className={s.previewEmpty}>(내용 없음)</span>
      )}
    </div>
  );
}
